const ImageHeroArcMaskLink = 'https://cdn.o2.cz/mojeo2-product/front-end/product-header-arc-mask.svg';

export default ImageHeroArcMaskLink;
